const AUTH_STORAGE_KEY = "manna_admin_auth";

function readStoredAuth() {
  const raw = localStorage.getItem(AUTH_STORAGE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setAuthSession({ token, tokenType, expiresInMs }) {
  const expiresAt = Date.now() + Number(expiresInMs || 0);
  const authData = {
    token,
    tokenType: tokenType || "Bearer",
    expiresInMs: Number(expiresInMs || 0),
    expiresAt,
  };

  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authData));
}

export function getAuthSession() {
  const auth = readStoredAuth();
  if (!auth) return null;

  if (!auth.token || !auth.expiresAt || Date.now() >= Number(auth.expiresAt)) {
    clearAuthSession();
    return null;
  }

  return auth;
}

export function getAccessToken() {
  const auth = getAuthSession();
  return auth ? auth.token : null;
}

export function isAuthenticated() {
  return Boolean(getAccessToken());
}

export function clearAuthSession() {
  localStorage.removeItem(AUTH_STORAGE_KEY);
  sessionStorage.removeItem("adminLoggedIn");
}
